// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";

// const SendMailFrontend: React.FC = () => {
//   const [file, setFile] = useState<File | null>(null);
//   const [loading, setLoading] = useState(false);

//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setFile(e.target.files?.[0] || null);
//   };

//   const handleSendMail = async () => {
//     if (!file) {
//       Swal.fire("Missing File", "Please select a file to send.", "warning");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file); // ✅ must match upload.single("file")

//     try {
//       setLoading(true);
//       const res = await axios.post("http://localhost:2600/sendMail", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.status === 200) {
//         Swal.fire("✅ Success", "Mail sent successfully!", "success");
//         setFile(null);
//       } else {
//         Swal.fire("❌ Error", res.data.message || "Failed to send email", "error");
//       }
//     } catch (error: any) {
//       console.error("❌ Error sending mail:", error);
//       Swal.fire("Error", "Network or server error.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         padding: "30px",
//         maxWidth: "500px",
//         margin: "50px auto",
//         border: "1px solid #ddd",
//         borderRadius: "10px",
//         boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
//         textAlign: "center",
//       }}
//     >
//       <h3>📧 Send Mail with Attachment</h3>
//       <input type="file" onChange={handleFileChange} />
//       <button onClick={handleSendMail} disabled={loading}>
//         {loading ? "Sending..." : "Send Mail"}
//       </button>
//     </div>
//   );
// };

// export default SendMailFrontend;


// import React, { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";

// const SendMailFrontend: React.FC = () => {
//   const [file, setFile] = useState<File | null>(null);
//   const [customerCode, setCustomerCode] = useState<string>("");
//    const [LocationCode, setLocationCode] = useState<string>("");
//   const [loading, setLoading] = useState(false);

//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     setFile(e.target.files?.[0] || null);
//   };

//   const handleSendMail = async () => {
//     if (!file) {
//       Swal.fire("Missing File", "Please select a file to send.", "warning");
//       return;
//     }

//     if (!customerCode) {
//       Swal.fire("Missing Customer Code", "Please enter a customer code.", "warning");
//       return;
//     }

//      if (!LocationCode) {
//       Swal.fire("Missing Customer Code", "Please enter a customer code.", "warning");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("customerCode", customerCode);
//     formData.append("LocationCode", LocationCode);

//     try {
//       setLoading(true);
//       const res = await axios.post("http://localhost:2600/sendMail", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.status === 200) {
//         Swal.fire("✅ Success", "Mail sent successfully!", "success");
//         setFile(null);
//         setCustomerCode("");
//       } else {
//         Swal.fire("❌ Error", res.data.message || "Failed to send email", "error");
//       }
//     } catch (error: any) {
//       console.error("❌ Error sending mail:", error);
//       Swal.fire("Error", "Network or server error.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div
//       style={{
//         padding: "30px",
//         maxWidth: "500px",
//         margin: "50px auto",
//         border: "1px solid #ddd",
//         borderRadius: "10px",
//         boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
//         textAlign: "center",
//       }}
//     >
//       <h3>📧 Send Mail with Attachment</h3>

//        <input
//         type="text"
//         placeholder="Enter Location Code (e.g. RV)"
//         value={LocationCode}
//         onChange={(e) => setLocationCode(e.target.value)}
//         style={{
//           width: "100%",
//           padding: "8px",
//           marginBottom: "15px",
//           border: "1px solid #ccc",
//           borderRadius: "5px",
//         }}
//       />

//       <input
//         type="text"
//         placeholder="Enter Customer Code (e.g. RV)"
//         value={customerCode}
//         onChange={(e) => setCustomerCode(e.target.value)}
//         style={{
//           width: "100%",
//           padding: "8px",
//           marginBottom: "15px",
//           border: "1px solid #ccc",
//           borderRadius: "5px",
//         }}
//       />

//       <input type="file" onChange={handleFileChange} />
//       <br />

//       <button
//         onClick={handleSendMail}
//         disabled={loading}
//         style={{
//           marginTop: "15px",
//           padding: "10px 20px",
//           backgroundColor: "#007bff",
//           border: "none",
//           borderRadius: "5px",
//           color: "#fff",
//           cursor: "pointer",
//         }}
//       >
//         {loading ? "Sending..." : "Send Mail"}
//       </button>
//     </div>
//   );
// };

// export default SendMailFrontend;



import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const SendMailFrontend: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [customerCode, setCustomerCode] = useState("");
  const [locationCode, setLocationCode] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFile(e.target.files?.[0] || null);
  };

  const handleSendMail = async () => {
    if (!file) return Swal.fire("Missing File", "Please select a file.", "warning");
    if (!customerCode.trim()) return Swal.fire("Missing Code", "Enter Customer Code.", "warning");
    if (!locationCode.trim()) return Swal.fire("Missing Code", "Enter Location Code.", "warning");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("customerCode", customerCode);
    formData.append("locationCode", locationCode);
    formData.append("subject", subject);
    formData.append("message", message);

    try {
      setLoading(true);
      const res = await axios.post("http://localhost:2600/sendMail", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.status === 200) {
        Swal.fire("✅ Success", "Mail sent successfully!", "success");
        setFile(null);
        setCustomerCode("");
        setLocationCode("");
        setSubject("");
        setMessage("");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("❌ Error", "Failed to send email.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        maxWidth: "500px",
        margin: "50px auto",
        border: "1px solid #ddd",
        borderRadius: "10px",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        textAlign: "center",
      }}
    >
      <h3>📧 Send Mail with Attachment</h3>

      <input
        type="text"
        placeholder="Enter Location Code"
        value={locationCode}
        onChange={(e) => setLocationCode(e.target.value)}
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Enter Customer Code"
        value={customerCode}
        onChange={(e) => setCustomerCode(e.target.value)}
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Enter Subject"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        style={inputStyle}
      />

      <textarea
        placeholder="Enter Message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        style={{ ...inputStyle, height: "100px" }}
      />

      <input type="file" onChange={handleFileChange} style={{ marginBottom: "15px" }} />

      <button
        onClick={handleSendMail}
        disabled={loading}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007bff",
          border: "none",
          borderRadius: "5px",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        {loading ? "Sending..." : "Send Mail"}
      </button>
    </div>
  );
};

const inputStyle = {
  width: "100%",
  padding: "8px",
  marginBottom: "15px",
  border: "1px solid #ccc",
  borderRadius: "5px",
};

export default SendMailFrontend;
